import {initContract} from '@ts-rest/core';
import {DB_SCHEMAS} from '../db/schemaExports';
import {z} from 'zod';
import {paginationQuerySchema, paginatedResponseSchema} from '../utils/pagination';

const c = initContract();

export const pendingInviteWithDetails = z.object({
  id: z.string().uuid(),
  recipientEmail: z.string(),
  roleTypeId: z.string().uuid(),
  scopeId: z.string().uuid(),
  invitedAt: z.coerce.date(),
  tenantName: z.string(),
  roleName: z.string()
});

export const invitesContract = c.router(
  {
    listMine: {
      method: 'GET',
      path: '/mine',
      responses: {
        200: z.object({
          data: z.array(pendingInviteWithDetails)
        })
      },
      summary: 'List pending invites for the authenticated user'
    },
    create: {
      method: 'POST',
      path: '/',
      body: z.object({
        tenantId: z.string(),
        recipientEmail: z.string().email(),
        roleType: z.enum(['admin', 'member'])
      }),
      responses: {
        201: DB_SCHEMAS.selectInvite,
        400: z.object({
          message: z.string()
        }),
        403: z.object({
          message: z.string()
        }),
        404: z.object({
          message: z.string()
        })
      },
      summary: 'Create an invite for a user to join a tenant'
    },
    list: {
      method: 'GET',
      path: '/',
      query: z
        .object({
          tenantId: z.string(),
          status: z.enum(['pending', 'accepted', 'withdrawn']).optional()
        })
        .merge(paginationQuerySchema)
        .extend({
          sortBy: z.enum(['recipientEmail', 'invitedAt']).optional()
        }),
      responses: {
        200: paginatedResponseSchema(DB_SCHEMAS.selectInvite),
        403: z.object({
          message: z.string()
        })
      },
      summary: 'List invites'
    },
    get: {
      method: 'GET',
      path: '/:id',
      pathParams: z.object({
        id: z.string()
      }),
      responses: {
        200: DB_SCHEMAS.selectInvite,
        403: z.object({
          message: z.string()
        }),
        404: z.object({
          message: z.string()
        })
      },
      summary: 'Get an invite by ID'
    },
    accept: {
      method: 'POST',
      path: '/:id/accept',
      pathParams: z.object({
        id: z.string()
      }),
      body: z.object({}),
      responses: {
        200: z.object({
          message: z.string(),
          role: DB_SCHEMAS.selectRole
        }),
        403: z.object({
          message: z.string()
        }),
        404: z.object({
          message: z.string()
        }),
        409: z.object({
          message: z.string()
        }),
        500: z.object({
          message: z.string()
        })
      },
      summary: 'Accept an invite'
    }
  },
  {
    pathPrefix: '/invites'
  }
);
